import type { SortDir } from "../../sort.js";

export interface SortableThProps<K extends string> {
  label: string;
  sortKey: K;
  activeKey: K;
  dir: SortDir;
  onSort: (key: K) => void;
}

export function SortableTh<K extends string>({
  label,
  sortKey,
  activeKey,
  dir,
  onSort,
}: SortableThProps<K>) {
  const active = sortKey === activeKey;
  return (
    <th aria-sort={active ? (dir === "asc" ? "ascending" : "descending") : undefined}>
      <button type="button" className="th-sort" onClick={() => onSort(sortKey)}>
        <span>{label}</span>
        <span aria-hidden="true" className={active ? "th-sort-ind" : "th-sort-ind th-sort-idle"}>
          {active ? (dir === "asc" ? "▲" : "▼") : "↕"}
        </span>
      </button>
    </th>
  );
}
